import { useWSModalCustom } from "@wingspanhq/fe-component-library";

import { EditRequirementDefinitionModal } from "./index";

export const useEditRequirementDefinitionModal = () =>
  useWSModalCustom(EditRequirementDefinitionModal);
